module.exports = __webpack_public_path__ + "img/blue_check.c8b8c135.svg";